import { createSlice } from '@reduxjs/toolkit';
import { PlacedPlacementGrouping, PlacementGrouping, ReceiptedPlacementGrouping, } from '../models';
const initialState = {
    receiptedIsBlocked: false,
    receiptedSearchTerm: '',
    receiptedGrouping: ReceiptedPlacementGrouping.None,
    receiptedItemCount: undefined,
    placedIsBlocked: false,
    placedSearchTerm: '',
    placedGrouping: PlacedPlacementGrouping.None,
    placedItemCount: undefined,
    isBlocked: false,
    searchTerm: '',
    grouping: PlacementGrouping.None,
    itemCount: undefined,
    blockPlacementItemDialog: {
        open: false,
        data: undefined,
    },
    assignPlaceDialog: {
        open: false,
        data: undefined,
    },
};
const slice = createSlice({
    name: 'placement',
    initialState,
    reducers: {
        // TODO: to delete later during Placement refactoring. All 4.
        setReceiptedIsBlocked: (state, action) => {
            state.receiptedIsBlocked = action.payload;
        },
        setReceiptedSearchTerm: (state, action) => {
            state.receiptedSearchTerm = action.payload;
        },
        setReceiptedGrouping: (state, action) => {
            state.receiptedGrouping = action.payload;
        },
        setReceiptedItemCount: (state, action) => {
            state.receiptedItemCount = action.payload;
        },
        // TODO: to delete later during Placement refactoring. All 4.
        setPlacedIsBlocked: (state, action) => {
            state.placedIsBlocked = action.payload;
        },
        setPlacedSearchTerm: (state, action) => {
            state.placedSearchTerm = action.payload;
        },
        setPlacedGrouping: (state, action) => {
            state.placedGrouping = action.payload;
        },
        setPlacedItemCount: (state, action) => {
            state.placedItemCount = action.payload;
        },
        setIsBlocked: (state, action) => {
            state.isBlocked = action.payload;
        },
        setSearchTerm: (state, action) => {
            state.searchTerm = action.payload;
        },
        setGrouping: (state, action) => {
            state.grouping = action.payload;
        },
        setItemCount: (state, action) => {
            state.itemCount = action.payload;
        },
        openBlockPlacementItemDialog: (state, action) => {
            state.blockPlacementItemDialog = {
                open: true,
                data: action.payload,
            };
        },
        closeBlockPlacementItemDialog: (state) => {
            state.blockPlacementItemDialog = initialState.blockPlacementItemDialog;
        },
        openAssignPlaceDialog: (state, action) => {
            state.assignPlaceDialog = {
                open: true,
                data: action.payload,
            };
        },
        closeAssignPlaceDialog: (state) => {
            state.assignPlaceDialog = initialState.assignPlaceDialog;
        },
    },
});
export const { actions: placementActions, reducer: placementStateReducer } = slice;
